/**
 *
 * @/functions/debug.js
 *
 * Description:
 * Stylized console.log for Chrome Inspector
 *
 */

export const logDebug = ({ box, boxColor = 'white', title, titleColor = 'blue', message = null }) => {
  message ? console.log(
    `:::: %c${box}%c ${title}:%c ${message}`,
    `
      background: #000;
      color: ${boxColor};
      font-weight: 700;
      padding: 2px 6px;
      border-radius: 4px;
    `,
    `
      color: ${titleColor};
      font-weight: 700;
    `,
    `
      color: #000;
      font-weight: 400;
    `
  ) : console.log(
    `:::: %c${box}%c ${title}`,
    `
      background: #000;
      color: ${boxColor};
      font-weight: 700;
      padding: 2px 6px;
      border-radius: 4px;
    `,
    `
      color: ${titleColor};
      font-weight: 700;
    `
  )
}
